import React from "react";
import { useNavigate } from "react-router-dom";
import UserReport from "../../components/DashboardInfo/UserReport";
import { ThemButton } from "../../components/Login/Login.style";
import { MainDiv } from "../../components/Profile/Profile.style";
import { SearchAddDiv } from "../../components/style/Table.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";

const UserReportPage = () => {
  const navigate = useNavigate();
  const moveDashboard = () => {
    navigate("/");
  };
  return (
    <MainDiv>
      <SearchAddDiv>
        <VolunteerHeading>Total User Report</VolunteerHeading>
        <div
          style={
            {
              // display: "flex",
              // justifyContent: "center",
            }
          }
        >
          <ThemButton onClick={() => moveDashboard()}>
            Back to dashboard
          </ThemButton>
        </div>
      </SearchAddDiv>
      <UserReport />
    </MainDiv>
  );
};

export default UserReportPage;
